import { render, staticRenderFns } from "./PromotionBundle.vue?vue&type=template&id=3bf52606&scoped=true"
import script from "./PromotionBundle.vue?vue&type=script&lang=js"
export * from "./PromotionBundle.vue?vue&type=script&lang=js"
import style0 from "./PromotionBundle.vue?vue&type=style&index=0&id=3bf52606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf52606",
  null
  
)

export default component.exports